import api from "../../utils/authFetch"

export const getSandboxUserPredictions = async (payload, options={}) => {
        const response = await api.post(`${process.env.REACT_APP_BACKEND_URL}/prediction/admin/sandbox-user-prediction`, payload, options)
        return response.data
}